import {meta} from "./i18n";

// What search engines and AI agents see: the site's name and address, and the parts of it that aren't for them.
// scripts/prerender.mjs, public/robots.txt and cloudfront/viewer-request.js follow these too (a test checks they agree).

export const SITE_ORIGIN = BUILD_SITE_ORIGIN;   // the stage's: https://tristaradvanced.com in prod
export const SITE_NAME = 'Tristar Advanced Software';
export const SITE_DESCRIPTION = meta.siteDescription;   // src/i18n/en/meta.ts

// Pages for signed-in users, and the sign-in screens: never prerendered, not indexed, disallowed in robots.txt.
export const PRIVATE_PATHS = ['/account', '/admin', '/support', '/checkout', '/login', '/forgot-password', '/reset-password', '/verify-email', '/news'];

// /products/:sku/download is for license holders too.
export function isPrivatePath(pathname: string): boolean {
    return PRIVATE_PATHS.some(x => pathname === x || pathname.startsWith(`${x}/`)) || /^\/products\/[^/]+\/download\/?$/.test(pathname);
}

export const absoluteUrl = (path: string) => `${SITE_ORIGIN}${path}`;
